export const VIDEO_CAPTURE = {
  INACTIVE_TIMEOUT: 12,
  FACE_VIDEO_TIMEOUT: 20,
  DOC_VIDEO_TIMEOUT: 30,
}

export const DOC_VIDEO_CAPTURE = {
  BUTTON_VISIBILITY_TIMEOUT: 3000,
  CAMERA_OVERLAY_TIMEOUT: 3000,
  SUCCESS_STATE_TIMEOUT: 2000,
  SUCCESS_STATE_VIBRATION: 500,
  HOLDING_STILL_TIMEOUT: 6000,
}

export const DOC_MULTIFRAME_CAPTURE = {
  PLACEHOLDER_TIMEOUT: 2000,
  SCANNING_TIMEOUT: 1500,
  SUCCESS_STATE_TIMEOUT: 1500,
  SUCCESS_STATE_VIBRATION: 500,
}
